import microuniversoApi from "app/api/microuniversoApi";
import globalMU from "globalMU";
import { tratamentoErroPadrao } from "app/use-cases";
import React, { useEffect, useState } from "react";
import { DadosCliente, DadosGuiaClienteContract, formularioVazio, FormularioDadosGuiaCliente } from "./DadosCliente";

const RTIPO_TELEFONE = 1071;
const RTIPO_FAX = 1072;
const RTIPO_EMAIL = 1073;
const RTIPO_CELULAR = 1075;
const RTIPO_SITE = 1076;

const RDEFINICAO_BANCO = 16983;
const RDEFINICAO_AGENCIA = 16984;
const RDEFINICAO_CONTA = 16985;

export const converterContractParaFormulario = (
  contract: DadosGuiaClienteContract
): FormularioDadosGuiaCliente => {
  if (!contract) return { ...formularioVazio };

  const telefones = (contract.Comunicacoes ?? []).filter((c) => c.Rtipo === RTIPO_TELEFONE);
  const emails = (contract.Comunicacoes ?? []).filter((c) => c.Rtipo === RTIPO_EMAIL);
  const fax = (contract.Comunicacoes ?? []).find((c) => c.Rtipo === RTIPO_FAX);
  const celular = (contract.Comunicacoes ?? []).find((c) => c.Rtipo === RTIPO_CELULAR);
  const site = (contract.Comunicacoes ?? []).find((c) => c.Rtipo === RTIPO_SITE);

  const banco = (contract.DadosAdicionais ?? []).find((d) => d.RDefinicao === RDEFINICAO_BANCO);
  const agencia = (contract.DadosAdicionais ?? []).find((d) => d.RDefinicao === RDEFINICAO_AGENCIA);
  const conta = (contract.DadosAdicionais ?? []).find((d) => d.RDefinicao === RDEFINICAO_CONTA);
  const crea = (contract.DadosAdicionais ?? []).find(
    (d) => d.RDefinicao !== RDEFINICAO_BANCO && d.RDefinicao !== RDEFINICAO_AGENCIA && d.RDefinicao !== RDEFINICAO_CONTA
  );

  return {
    Tel1: telefones[0]?.Valor ?? "",
    Tel2: telefones[1]?.Valor ?? "",
    Fax: fax?.Valor ?? "",
    Mail1: emails[0]?.Valor ?? "",
    Mail2: emails[1]?.Valor ?? "",
    Mail3: emails[2]?.Valor ?? "",
    Site: site?.Valor ?? "",
    Celular: celular?.Valor ?? "",
    Banco: banco?.Valor ?? "",
    Agencia: agencia?.Valor ?? "",
    Conta: conta?.Valor ?? "",
    Crea: crea?.Valor ?? "",
    ContatoNome: contract.Contato?.Nome ?? "",
    ContatoCargo: contract.Contato?.Cargo ?? "",
  };
};

export type DadosClienteContainerProps = {
  oidCliente: number;
  identificadorOrcamento: string;
  somenteLeitura: boolean;
  permitirAlterarDadosBasicos: boolean;
  manterDadosTemporarios: (dados: FormularioDadosGuiaCliente) => void;
  onDadosGuiaClienteOriginalCarregado: (original: DadosGuiaClienteContract) => void;
};

export const DadosClienteContainer = (props: DadosClienteContainerProps) => {
  const [dados, setDados] = useState<FormularioDadosGuiaCliente>({ ...formularioVazio });

  const onObterDadosGuiaCliente = async () => {
    try {
      globalMU.blockUI();
      const resposta = await microuniversoApi.Cliente.obterDadosGuiaCliente(
        props.oidCliente,
        props.identificadorOrcamento
      );
      if (!("HasErrors" in resposta)) {
        props.onDadosGuiaClienteOriginalCarregado(resposta);
        setDados(converterContractParaFormulario(resposta));
      }
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  useEffect(() => {
    if (props.oidCliente > 7) {
      onObterDadosGuiaCliente();
    }
  }, [props.oidCliente, props.identificadorOrcamento]);

  return (
    <DadosCliente
      somenteLeitura={props.somenteLeitura}
      permitirAlterarDadosBasicos={props.permitirAlterarDadosBasicos}
      dados={dados}
      manterDadosTemporarios={props.manterDadosTemporarios}
    />
  );
};
